import React, { useState } from 'react';
import { ErrorMessage, FieldHookConfig, useField } from 'formik';
import { BiErrorCircle } from 'react-icons/bi';
interface IProps {
  label?: string | number;
  placeholder?: string;
  value?: string;
  type?: string;
  defaultValue?: string | number;
  readOnly?: boolean;
  hidden?: boolean;
  ref?: any;
  className?: string;
  labelClassName?: string;
  inputClassName?: string;
  icon?: any;
  isdisable?: boolean;
}
const TextField = ({
  label,
  placeholder,
  type,
  readOnly,
  defaultValue,
  hidden,
  ref,
  className,
  labelClassName,
  inputClassName,
  icon,
  isdisable,
  ...otherProps
}: IProps & FieldHookConfig<string>) => {
  const [field, meta] = useField(otherProps);
  return (
    <div className={`${className} mb-5`}>
      <label
        className={` capitalize text-base mb-2 text-text-black block${
          meta.error && meta.touched ? 'text-warning' : ''
        } ${labelClassName} `}
        htmlFor={field.name}
      >
        {label}
      </label>

      <div className="flex-1">
        <div className="relative">
          <input
            className={`${inputClassName}  w-full appearance-none text-text-black placeholder:capitalize rounded-xl py-3 block placeholder:text-sm px-3 bg-pure-white text-sm ring-1 ring-light-grey focus-within:ring-1 focus-within:ring-primary focus-within:outline-0"  ${
              meta.touched && meta.error
                ? 'focus-within:ring-1 bg-[red] focus-within:ring-warning focus-within:outline-none text-warning placeholder:text-warning'
                : 'focus-within:ring-1 focus-within:ring-primary focus-within:outline-none'
            } `}
            {...field}
            type={type}
            defaultValue={defaultValue}
            placeholder={placeholder}
            autoComplete="off"
            readOnly={readOnly}
            disabled={isdisable}
          />
          <div className="absolute top-3 right-3">{icon}</div>
        </div>
        <div className="relative">
          {meta.touched && meta.error && (
            <BiErrorCircle
              size={17}
              color="#fff"
              className="absolute top-2 mx-2"
            />
          )}

          <ErrorMessage
            component="div"
            name={field.name}
            className="bg-warning bg-opacity-80 text-pure-white mt-1 text-xs inline-block px-7 py-1 rounded-sm"
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(TextField);
